import { ReactElement } from 'react';
import classnames from 'classnames';

import { IconWrapperComponentSize16 } from '@hh.ru/magritte-ui-icon/iconTypes';
import { TagProps } from '@hh.ru/magritte-ui-tag/types';

import styles from './tag.less';

const SIZE_TO_CSS = {
    large: styles.tagSizeLarge,
    medium: styles.tagSizeMedium,
};

const STYLE_TO_CSS = {
    special: styles.tagStyleSpecial,
    warning: styles.tagStyleWarning,
    positive: styles.tagStylePositive,
    negative: styles.tagStyleNegative,
    neutral: styles.tagStyleNeutral,
    accent: styles.tagStyleAccent,
};

export const Tag = <C, I>({
    style = 'neutral',
    size = 'medium',
    disabled = false,
    hideLabel,
    icon,
    'aria-label': ariaLabel,
    children,
}: TagProps<C, I>): ReactElement => {
    const showLabel = !hideLabel && children;
    const IconComponent: IconWrapperComponentSize16 | null = icon ?? null;
    return (
        <div
            className={classnames(styles.tag, STYLE_TO_CSS[style], SIZE_TO_CSS[size], {
                [styles.tagStateDisabled]: disabled,
            })}
        >
            {IconComponent && (
                <div className={styles.tagIcon}>
                    <IconComponent aria-label={!showLabel ? ariaLabel : undefined} />
                </div>
            )}
            {showLabel && <div className={styles.tagLabel}>{children}</div>}
        </div>
    );
};
